"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERVIEW = void 0;
var OVERVIEW = {
  TEXT__OUTLET_NAME: 'newOrderFlow-span-outletName',
  TEXT__PRODUCT_NAME: 'newOrderFlow-div-productName',
  TEXT__PRODUCT_QUANTITY: 'newOrderFlow-span-productQuantity',
  TEXT__PRODUCT_PRICE: 'newOrderFlow-span-productPrice',
  TEXT__TOTAL: 'newOrderFlow-span-total',
  TEXT__DELIVERY_FEE: 'newOrderFlow-span-deliveryFee',
  BUTTON__UPLOAD_FILES: 'newOrderFlow-button-uploadFiles',
  BUTTON__EDIT_OUTLET: 'newOrderFlow-button-editOutlet',
  BUTTON__EDIT_PRODUCTS: 'newOrderFlow-button-editProducts',
  BUTTON__DELIVERY_FEE: 'newOrderFlow-button-deliveryFee',
  TEXTAREA__NOTE: 'newOrderFlow-textarea-note'
};
exports.OVERVIEW = OVERVIEW;